class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#predictive-search');
        this.predictiveSearchText = this.querySelector('#predictive-search-results-text');
        this.clearButton = this.querySelector('.search-bar-cross');
        this.ghostCards = this.querySelector('#ghost-cards');
        this.ghostText = this.querySelector('#predictive-search-text-ghost');

        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));

        this.clearButton.addEventListener('click', () => {
            this.clearInput();
        });
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            this.clearButton.style.display = 'none';
            this.hideGhostCards();
            return;
        }

        this.clearButton.style.display = 'block';
        this.showGhostCards();
        this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
        fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#predictive-search-results').innerHTML;
                const predictiveSearchTextElement = new DOMParser().parseFromString(text, 'text/html').querySelector('#predictive-search-text').innerHTML;
                this.predictiveSearchResults.innerHTML = resultsMarkup;
                this.predictiveSearchText.innerHTML = predictiveSearchTextElement;
                
                this.hideGhostCards();
                this.open();
            })
            .catch((error) => {
                this.hideGhostCards();
                this.close();
                throw error;
            });
    }

    open() {
        this.hideGhostCards();
        this.predictiveSearchResults.style.display = 'block';
        this.predictiveSearchText.style.display = 'block';
    }

    close() {
        this.predictiveSearchResults.style.display = 'none';
        this.predictiveSearchText.style.display = 'none';
    }

    showGhostCards() {
        this.close();
        this.ghostCards.classList.remove('hidden');
        this.ghostText.classList.remove('hidden');
    }

    hideGhostCards() {
        this.ghostCards.classList.add('hidden');
        this.ghostText.classList.add('hidden');
    }

    clearInput() {
        this.input.value = '';
        this.input.focus();
        this.hideGhostCards();
        this.close();
        this.clearButton.style.display = 'none';
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => {
                if (!this.input.value.trim().length) {
                    this.hideGhostCards();
                    this.close();
                    this.clearButton.style.display = 'none';
                }
                fn.apply(this, args);
            }, wait);
        };
    }
}

customElements.define('predictive-search', PredictiveSearch);

function initSearchAnimation() {
  if (typeof gsap === 'undefined') {
    setTimeout(initSearchAnimation, 100);
    return;
  }

  const searchOpenTrigger = document.querySelectorAll(".search-toggle");
  let searchOpen = false;
  const searchCloseTrigger = document.querySelectorAll("button#search-close");
  const searchTL = gsap.timeline({ paused: true });
  const searchBody = document.querySelector("#predictive-search");
  const searchmm = gsap.matchMedia();


searchmm.add("(min-width: 911px)", () => {
  searchTL
    .set(searchBody, {
      display: "flex",
    })
    .fromTo(
      searchBody,
      {
        clipPath: "inset(45% 20% 55% 20% round 1.5rem 1.5rem 1.5rem 1.5rem)",
      },
      {
        clipPath: "inset(0% 0% 0% 0% round 0rem 0rem 0rem 0rem)",
        duration: 1,
        ease: "expo.inOut",
      },
      "<"
    );
});

searchmm.add("(max-width: 911px)", () => {
  searchTL
    .set(searchBody, {
      display: "flex",
    })
    .fromTo(
      searchBody,
      {
        clipPath: "inset(35% 50% 35% 50% round 1.5rem 1.5rem 1.5rem 1.5rem)",
      },
      {
        clipPath: "inset(0% 0% 0% 0% round 0rem 0rem 0rem 0rem)",
        duration: 1,
        ease: "expo.inOut",
      },
      "<"
    );
});

  searchOpenTrigger.forEach((el) => {
    const searchRoot = document.querySelector(".search-modal");
    
    el.addEventListener("click", () => {
      
      if (searchOpen) {
        return;
      }
      
      searchRoot.classList.add("active");
      document.body.style.overflow = "hidden";
      searchBody.classList.toggle("active");
      searchTL.timeScale(1).play();
      searchOpen = true;
      
      setTimeout(() => {
        const searchInput = document.querySelector('#search-input');
        if (searchInput) {
          searchInput.focus();
        }
      }, 100);
    });
  });

  searchCloseTrigger.forEach((el) => {
    
    el.addEventListener("click", () => {
      const searchRoot = document.querySelector(".search-modal");
      setTimeout(() => {
        searchRoot.classList.remove("active");
      }, 500);
      document.body.style.overflow = "auto";
      searchTL.timeScale(2).reverse();
      searchOpen = false;
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSearchAnimation);
} else {
  initSearchAnimation();
}
